const UPDATE_PAGINATION = 'UPDATE_PAGINATION';
const RESET_PAGINATION = 'RESET_PAGINATION';

const state = () => ({
  pageNum: 1, // 当前分页
  pageSize: 10, // 分页大小
  startRow: 0,
  endRow: 0,
  total: 0,
  pages: 0,
});

const getters = {
  pagination: state => state,
};

const actions = {
  updatePagination({ commit }, pagination) {
    commit(UPDATE_PAGINATION, pagination);
  },
  resetPagination({ commit }) {
    commit(RESET_PAGINATION);
  },
};

const mutations = {
  [UPDATE_PAGINATION](state, pagination) {
    state = Object.assign(state, {
      ...pagination,
    });
  },
  [RESET_PAGINATION](state) {
    state = Object.assign(state, {
      pageNum: 1, // 当前分页
      pageSize: 10, // 分页大小
      total: 0,
      pages: 0,
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
